var render = function render(){var _vm=this,_c=_vm._self._c;return _c('divBox',{staticClass:"realTimeBox",attrs:{"title":'最新告警列表信息'}},[_c('dv-scroll-board',{staticClass:"margin-top-sm realTimeList",attrs:{"config":_vm.config}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }